export default __webpack_public_path__ + "static/media/attitudeLineChart.f5c5f5f9.png";